import React from 'react';

import { ChatRoleEnum } from 'app/api/ApiTypes';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import TextButton from 'components/Buttons/TextButton/TextButton';

import { AssistantMessageDetails } from 'app/models';

import block from 'utils/bem-css-modules';
import { formatMessage } from 'utils/messages/utils';

import AssistantIcon from './AssistantIcon';
import style from './AssistantMessage.module.pcss';

const b = block(style);

type AssistantMessageProps = {
  message: AssistantMessageDetails;
  onActionConfirmation: (confirmed: boolean) => void;
  isLatest: boolean;
};

const AssistantMessage: React.FC<AssistantMessageProps> = ({ message, onActionConfirmation, isLatest }) => {
  const isHuman = message.content.role === ChatRoleEnum.human;

  const isActionConfirmation = message.content.isActionConfirmation;

  return (
    <div className={b()}>
      <div className={b('chatDetails', { ai: !isHuman })} data-testid="assistant-message-details">
        {!isHuman ? <AssistantIcon /> : null}
      </div>
      <div className={b('chatBubble', { ai: !isHuman })} data-testid="assistant-message-bubble">
        <div className={b('chatBubbleInner')}>
          <Markdown remarkPlugins={[remarkGfm]}>{message.content.message}</Markdown>
        </div>
      </div>
      {isActionConfirmation && isLatest && (
        <div className={b('actionConfirmationButtons')}>
          <TextButton
            text={formatMessage('APPROVE')}
            type="button"
            onClick={() => onActionConfirmation(true)}
            testId="action-confirmation-yes"
            disabled={!isLatest}
          />
          <TextButton
            text={formatMessage('REJECT')}
            type="button"
            onClick={() => onActionConfirmation(false)}
            testId="action-confirmation-no"
            disabled={!isLatest}
          />
        </div>
      )}
    </div>
  );
};

export default AssistantMessage;
